import { render, staticRenderFns } from "./RegistrarCliente.vue?vue&type=template&id=66508b30&scoped=true"
import script from "./RegistrarCliente.vue?vue&type=script&lang=js"
export * from "./RegistrarCliente.vue?vue&type=script&lang=js"
import style0 from "./RegistrarCliente.vue?vue&type=style&index=0&id=66508b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66508b30",
  null
  
)

export default component.exports